import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GameSettingsService } from '@app/core/services/game-settings.service';
import { Observable } from 'rxjs';

@Injectable()
export class AcceptLanguageHeaderInterceptor implements HttpInterceptor {

  constructor(private gameSettingsService: GameSettingsService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.gameSettingsService.gameSettings()?.jeopardyEnglishFallback) {
      const modifiedReq = req.clone({
        setHeaders: {
          'Accept-Language': 'en-GB'
        }
      });

      return next.handle(modifiedReq);
    }
    return next.handle(req);
  }
}
